import { api } from "../services/Api";
import { showToast } from "../utils";

export function useFeatureToggles() {
  const baseUrl = '/feature-toggles'
  async function loadInitialData() {
    try {
      return await api.get(`${baseUrl}`, {})
    } catch (error) {
      showToast({
        type: "error",
        message: "Falha ao c"
      })
    }
  }
  const postFeatureToggles = async (featureTogglesData: any) => {
    return await api.post(`${baseUrl}`, featureTogglesData);
  }
  
  return {
    loadInitialData,
    postFeatureToggles,
  }
}